var _style, _rect, _path, _path2, _path3, _polyline, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatDetector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    className: "st0",
    width: 13.1,
    height: 12.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,0.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,13.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,11.4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1.4,13.4 1.4,15.5 14.6,15.5 14.6,13.4 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5,
    y1: 2.6,
    x2: 12.4,
    y2: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.6,
    y1: 4.2,
    x2: 10.7,
    y2: 11.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.6,
    y1: 4.1,
    x2: 5.3,
    y2: 11.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.1,
    y1: 2.6,
    x2: 3.9,
    y2: 9.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDetector);
export default __webpack_public_path__ + "static/media/HeatDetector.0f1e504977933d53fa2f584abf4d68d3.svg";
export { ForwardRef as ReactComponent };